<div class="fancy-hero-one">
    <div class="container">
      <div class="row">
        <div class="col-xl-9 col-lg-11 m-auto">
          <!-- <div class="page-title">Contact us</div> -->
          <h2 class="font-rubik">Search Asset</h2>
        </div>
      </div>
    </div>
  </div>

  <div class="hero-banner-one contact-us-light">
    <div class="hero-upper-container">
        <div class="container d-flex align-items-center justify-content-center">
          <form ngNativeValidate id="contact-form" data-bs-toggle="validator">
            <div class="form-style-light">
              <div class="row controls">
                <div class="col-md-6">
                  <div class="input-group-meta form-group mb-25">
                    <label>Name</label>
                    <input  type="text" placeholder="Enter Name" name="name" [(ngModel)]="name">
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="input-group-meta form-group mb-25">
                    <label>Mobile No.</label>
                    <input  type="number" placeholder="Enter Mobile No." name="mobile" 
                    [(ngModel)]="mobile_no">
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="input-group-meta form-group mb-25">
                    <label>Email</label>
                    <input  type="email" placeholder="Enter Email" name="email" [(ngModel)]="email">
                  </div>
                </div>

                <div *ngIf="env.environmentName != 'srinagar'"  class="col-md-6">
                  <div class="input-group-meta form-group mb-25">
                    <label>ULB*</label>
                    <select  [ngModelOptions]="{standalone: true}" [(ngModel)]="ulb_id" (ngModelChange)="onUlbChange()">
                      <option value="">Select</option>
                      <option *ngFor="let option of ulb_data" [ngValue]="option.id">{{option?.name}}</option>
                    </select>             
                  </div>
                </div>

                <ng-container *ngFor="let model of modelData['regionHierarchyUlb']; let i = index">
                  <div class="col-md-6">
                    <div class="input-group-meta form-group mb-25"> 
                  <label>{{model?.field_label}}</label>
                    <select  [ngModelOptions]="{standalone: true}" (ngModelChange)="modelChange($event, model, 'regionHierarchyUlb', i, 2)"  [(ngModel)]="modelData['regionHierarchyUlb'][i].ngmodel">
                      <option value="">Select</option>
                      <option *ngFor="let option of model.field_data" [ngValue]="option">{{option?.label}}</option>
                    </select>
                    </div>
                    </div>
                </ng-container>
                
              </div>
              <div class="row controls">     
                <div class="col-md-12">
                  <div class="input-group-meta form-group mb-25">
                    <label>Address</label>
                    <input  type="text"  placeholder="Enter Address"
                    name="address" [(ngModel)]="address">
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <button class="theme-btn-one btn-lg" (click)="onSearchClick()"
                >Search</button>
              </div>
            </div>
          </form>
        </div>

        <div class="container">
          <div class="table_wrap">
          <table *ngIf="property_list.length > 0" class="table table_design mt-50">
            <thead>
              <tr>
                <th scope="col">Asset Id</th>
                <th scope="col">Asset Type</th>
                <th scope="col">Name of Household</th>
                <th scope="col">Address</th>
                <!-- <th scope="col">Email</th> -->
                <th scope="col">ULB</th>
                <th scope="col">Zone</th>
                <th scope="col">Ward</th>
                <th scope="col">Action</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let data of property_list; index as i">
                <td scope="row">{{ data?.property_uid }}</td>
                <td scope="row">{{ data?.property_type?.type_name }}</td>
                <td>
                  {{ data?.consumer?.name }}
                </td>
                <td>{{ data?.consumer?.address}}</td>
                <!-- <td>{{ data?.consumer?.email}}</td> -->
                <td>{{ data?.ulb?.name}}</td>
                <td>{{ data?.region?.parents?.region_name}}</td>
                <td>{{ data?.region?.region_name}}</td>
                <td>
                  <button matTooltip="View Detail" [routerLink]="['/property-detail']" [queryParams]="{ property_id: data?.property_uid}" class="theme-btn-one">Detail</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

          <ngb-pagination  *ngIf="property_list.length > 0" [collectionSize]="totalCount" [pageSize]="perPage"
                [(page)]="page" (pageChange)="getSearviceNumberList()" [maxSize]=7 class="pull-right justify-content-end page-mt-10"
          aria-label="Default pagination"></ngb-pagination>
        </div>
  </div>
  </div>
  